module.exports = __webpack_public_path__ + "static/media/pay37.2f1037c6.png";